import "./MatchKeyEventComponents.css";

import { ISoccerMatchPenaltyShotEvent } from "../../../../../../../types";

export const PenaltyShotEvent = ({
  event,
  isHomeTeamEvent,
  isAwayTeamEvent,
}: {
  event: ISoccerMatchPenaltyShotEvent;
  isHomeTeamEvent: boolean;
  isAwayTeamEvent: boolean;
}) => {
  return (
    <div className="match-key-event">
      <span className="home-team-match-key-event">
        {isHomeTeamEvent && (
          <>
            <span className="event-player-name">{event.scorerName}</span>
            <img
              src={
                event.outcome === "scored"
                  ? "/images/match-events/penalty-goal.svg"
                  : "/images/match-events/missed-penalty.svg"
              }
              height={13}
              width={13}
              alt={"missed-penalty"}
              className=""
            />
          </>
        )}
      </span>
      <span className="time-match-key-event">{`${event?.timeMin}'`}</span>
      <span className="away-team-match-key-event">
        {isAwayTeamEvent && (
          <>
            <img
              src={
                event.outcome === "scored"
                  ? "/images/match-events/penalty-goal.svg"
                  : "/images/match-events/missed-penalty.svg"
              }
              height={13}
              width={13}
              alt={"penalty"}
              className=""
            />
            <span className="event-player-name">{event.scorerName}</span>
          </>
        )}
      </span>
    </div>
  );
};
